// extracted by mini-css-extract-plugin
module.exports = {"container":"supplier-faq_container__qvmHQ","title":"supplier-faq_title__3hj0U","answer":"supplier-faq_answer__7IyEd"};